import { Linkedin, Mail } from "lucide-react";

const XIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export default function ShareButtons({ title, url }) {
  const encoded = encodeURIComponent(url || window.location.href);
  const encodedTitle = encodeURIComponent(title || "");

  const links = [
    {
      label: "LinkedIn",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`,
      icon: Linkedin,
      color: "hover:text-[#0A66C2]",
    },
    {
      label: "X",
      href: `https://x.com/intent/tweet?url=${encoded}&text=${encodedTitle}`,
      icon: XIcon,
      color: "hover:text-white",
    },
    {
      label: "Email",
      href: `mailto:?subject=${encodedTitle}&body=${encoded}`,
      icon: Mail,
      color: "hover:text-[#D4AF37]",
    },
  ];

  return (
    <div className="flex items-center gap-4" data-testid="share-buttons">
      <span className="text-slate-500 text-xs uppercase tracking-widest">Share</span>
      {links.map((link) => (
        <a
          key={link.label}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`share-${link.label.toLowerCase()}`}
          className={`text-slate-500 ${link.color} transition-colors duration-200`}
          aria-label={`Share on ${link.label}`}
        >
          <link.icon size={16} />
        </a>
      ))}
    </div>
  );
}
